export default {
    "name": "TeardownCreateInventory",
    "kind": "HoudiniMutation",
    "hash": "811b9b072548f1e4007dfe9251bfb4caf5b60d5299cf32b4e9c83903b9c3ba10",

    "raw": `mutation TeardownCreateInventory($input: NewInventory!) {
  createInventory(input: $input) {
    inventoryId
    storeId
    id
  }
}
`,

    "rootType": "Mutation",
    "stripVariables": [],

    "selection": {
        "fields": {
            "createInventory": {
                "type": "Inventory",
                "keyRaw": "createInventory(input: $input)",

                "selection": {
                    "fields": {
                        "inventoryId": {
                            "type": "Int",
                            "keyRaw": "inventoryId",
                            "visible": true
                        },

                        "storeId": {
                            "type": "UInt",
                            "keyRaw": "storeId",
                            "visible": true
                        },

                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "input": "NewInventory"
        },

        "types": {
            "NestedNewInventoryAttachment": {
                "file": "Upload",
                "fileId": "UInt",
                "public": "Boolean",
                "rank": "Int"
            },

            "NewCollectionMember": {
                "costFactor": "Decimal2",
                "existingSkuNumber": "UInt",
                "integral": "Boolean",
                "newInventory": "NewInventory",
                "quantity": "Decimal6"
            },

            "NewCollection": {
                "members": "NewCollectionMember",
                "type": "CollectionTypeEnum"
            },

            "InventoryLocationInput": {
                "locationId": "Int",
                "locationName": "String",
                "permanent": "Boolean",
                "quantity": "Decimal6",
                "rank": "Int"
            },

            "InventoryOptionValueUpdate": {
                "inventoryOptionId": "Int",
                "value": "String"
            },

            "SaleClassReference": {
                "code": "String",
                "id": "Int"
            },

            "NestedNewInventorySerial": {
                "location": "String",
                "number": "String",
                "optionValues": "InventoryOptionValueUpdate"
            },

            "DimensionsInput": {
                "height": "Decimal2",
                "length": "Decimal2",
                "measurementUnit": "DimensionsMeasurementUnit",
                "weight": "Decimal6",
                "weightUnit": "DimensionsWeightUnit",
                "width": "Decimal2"
            },

            "NewInventory": {
                "attachments": "NestedNewInventoryAttachment",
                "bodyStyle": "String",
                "buyPackage": "Int",
                "categoryId": "UInt",
                "collection": "NewCollection",
                "condition": "String",
                "coreClass": "String",
                "coreCost": "Decimal2",
                "coreRequired": "Boolean",
                "coreRequiredToVendor": "Boolean",
                "cost": "Decimal2",
                "daysToReturn": "UInt",
                "daysToReturnCore": "UInt",
                "daysToReturnCoreToVendor": "UInt",
                "daysToReturnToVendor": "UInt",
                "defaultVendorId": "UInt",
                "deplete": "Boolean",
                "description": "String",
                "distributorCorePrice": "Decimal2",
                "distributorPrice": "Decimal2",
                "freezeUntil": "Date",
                "glCategoryId": "UInt",
                "interchangeNumber": "String",
                "inventoryTypeId": "UInt",
                "jobberCorePrice": "Decimal2",
                "jobberPrice": "Decimal2",
                "listPrice": "Decimal2",
                "locations": "InventoryLocationInput",
                "manufacturerId": "Int",
                "maxQuantity": "Decimal6",
                "minQuantity": "Decimal6",
                "modelId": "Int",
                "notes": "String",
                "oemNumber": "String",
                "optionValues": "InventoryOptionValueUpdate",
                "parentManufacturerId": "UInt",
                "parentModelId": "UInt",
                "partNumber": "String",
                "popularityCode": "String",
                "priceGroup": "String",
                "printTag": "Boolean",
                "public": "Boolean",
                "purchaseFactor": "Boolean",
                "quantity": "Decimal6",
                "replenishable": "Boolean",
                "retailCorePrice": "Decimal2",
                "retailPrice": "Decimal2",
                "returnable": "Boolean",
                "returnableToVendor": "Boolean",
                "safetyStockPercent": "Decimal2",
                "saleClass": "SaleClassReference",
                "seasonal": "Boolean",
                "sellPackage": "UInt",
                "sellPriceClassId": "Int",
                "serialized": "Boolean",
                "serials": "NestedNewInventorySerial",
                "shippingDimensions": "DimensionsInput",
                "side": "SideEnum",
                "singleQuantity": "Boolean",
                "sku": "Int",
                "status": "StatusEnum",
                "stockMethod": "StockMethodEnum",
                "stockType": "StockTypeEnum",
                "stockingDays": "Int",
                "storeId": "UInt",
                "subInterchangeNumber": "String",
                "tagNumber": "String",
                "taxable": "Boolean",
                "typeData1": "String",
                "typeData2": "String",
                "typeData3": "String",
                "typeData4": "String",
                "userStatus": "String",
                "vehicleId": "UInt",
                "vehicleMake": "String",
                "vehicleModel": "String",
                "vehicleVin": "String",
                "vehicleYear": "UInt",
                "vendorPopularityCode": "String",
                "vendorProductCode": "String",
                "wholesaleCorePrice": "Decimal2",
                "wholesalePrice": "Decimal2"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    }
};

"HoudiniHash=803b9a99a81f8a00a3a5a1dc4bd055663a4d76dfc9ea72edebf06c8a0d1615c2";